/*
 * Copyright (c) 2020 wlocalhost.org.
 * All rights reserved.
 */

import FreeUsersIpStorage from './FreeUsersStorage.class';
export {FreeUsersIpStorage};
